<template>
  
    <v-img v-if="light" :width="width" :height="height" src="https://cdn.kyano.app/img/kyano-forms-icon-logo-dark.svg"></v-img>
    <v-img v-else  :width="width" :height="height" src="https://cdn.kyano.app/img/kyano-forms-icon-logo-dark.svg"></v-img>

</template>


<script>
export default {
  props: {   
    width: String,
    height: String,
    content: String,
  
  },
};
</script>